export function removeLeading0s(str: string) {
  return str.replace(/^0+/, '');
}

export function shortenString(str: string, keep: number) {
  if (str.length <= keep * 2) return str; // No need to shorten if string is shorter than or equal to the required length
  return `${str.slice(0, keep)}...${str.slice(-keep)}`;
}
